// extracted by mini-css-extract-plugin
export var container = "_cx-0";
export var icon = "_cx-1";
export var text = "_cx-2";